function escapeCell(value) {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (/[";\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

function baixar(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function escapeHtml(value) {
  if (value === null || value === undefined) return '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

// Cores da marca Centrao (logo): verde e laranja.
export const CORES_CENTRAO = {
  verde: '#3D874C',
  verdeRgb: [61, 135, 76],
  verdeClaroRgb: [236, 245, 238],
  laranja: '#F7963A',
  laranjaRgb: [247, 150, 58],
};

function tabelaHtml(titulo, columns, rows) {
  const th = `style="background:${CORES_CENTRAO.verde};color:#ffffff;font-weight:bold;border:1px solid #2f6b3c"`;
  const head = columns.map((c) => `<th ${th}>${escapeHtml(c.label)}</th>`).join('');
  const body = rows
    .map((row, i) => `<tr${i % 2 ? ' style="background:#ECF5EE"' : ''}>${columns.map((c) => `<td style="border:1px solid #c9d6cc">${escapeHtml(c.value(row))}</td>`).join('')}</tr>`)
    .join('');
  const cab = titulo
    ? `<h3 style="color:${CORES_CENTRAO.verde};border-bottom:3px solid ${CORES_CENTRAO.laranja}">Centrão — ${escapeHtml(titulo)}</h3>`
    : '';
  return `${cab}<table border="1"><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>`;
}

// Carrega uma imagem (ex.: o logo importado pelo webpack) como dataURL.
async function imagemDataUrl(url) {
  const blob = await (await fetch(url)).blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// Excel sem dependencia: tabela HTML com mime do Excel (.xls). O Excel abre
// direto (pode avisar que o formato difere da extensao).
export function exportToExcel(filename, columns, rows, titulo = '') {
  const html = `<html xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head>`
    + `<body>${tabelaHtml(titulo, columns, rows)}</body></html>`;
  const blob = new Blob([`﻿${html}`], { type: 'application/vnd.ms-excel;charset=utf-8;' });
  baixar(blob, filename.endsWith('.xls') ? filename : `${filename}.xls`);
}

// A fonte padrao do PDF (Helvetica/WinAnsi) nao tem alguns simbolos unicode.
function textoPdf(valor) {
  if (valor === null || valor === undefined) return '';
  return String(valor).replace(/−/g, '-').replace(/[←-⯿\u{1F000}-\u{1FFFF}]/gu, '');
}

// PDF em texto vetorial (jsPDF, que ja vem com o html2pdf.js): nitido em
// qualquer zoom e impressao, ao contrario de "fotografar" a tela.
//   columns: { label, value(row), peso?, alinhar?: 'right' }  — `peso` e a
//            largura relativa da coluna (default 1)
//   opcoes:  string (titulo) ou { titulo, subtitulo, logo } — `logo` e a URL
//            de uma imagem (o logo do Centrao) para o topo da 1a pagina
export async function exportToPdf(filename, columns, rows, opcoes = {}) {
  const { titulo = '', subtitulo = '', logo = null } = typeof opcoes === 'string' ? { titulo: opcoes } : opcoes;
  const { jsPDF } = await import('jspdf');
  const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

  const COR_CABECALHO = CORES_CENTRAO.verdeRgb;
  const COR_ZEBRA = CORES_CENTRAO.verdeClaroRgb;
  const COR_LINHA = [201, 214, 204];
  const margem = 10;
  const larguraPagina = doc.internal.pageSize.getWidth();
  const alturaPagina = doc.internal.pageSize.getHeight();
  const larguraUtil = larguraPagina - margem * 2;
  const pesoTotal = columns.reduce((s, c) => s + (c.peso || 1), 0);
  const larguras = columns.map((c) => (larguraUtil * (c.peso || 1)) / pesoTotal);
  const FONTE = 8;
  const ALTURA_LINHA_TEXTO = 3.6;
  const PAD = 1.6;
  const geradoEm = new Date().toLocaleString('pt-BR');

  let y = margem;

  const cabecalhoTabela = () => {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(FONTE);
    const linhas = columns.map((c, i) => doc.splitTextToSize(textoPdf(c.label), larguras[i] - PAD * 2));
    const altura = Math.max(...linhas.map((l) => l.length)) * ALTURA_LINHA_TEXTO + PAD * 2;
    doc.setFillColor(...COR_CABECALHO);
    doc.rect(margem, y, larguraUtil, altura, 'F');
    doc.setTextColor(255, 255, 255);
    let x = margem;
    columns.forEach((c, i) => {
      const tx = c.alinhar === 'right' ? x + larguras[i] - PAD : x + PAD;
      doc.text(linhas[i], tx, y + PAD + 2.8, { align: c.alinhar === 'right' ? 'right' : 'left' });
      x += larguras[i];
    });
    y += altura;
  };

  const novaPagina = () => {
    doc.addPage();
    y = margem;
    cabecalhoTabela();
  };

  // Cabecalho: logo do Centrao + titulo em verde + faixa laranja
  let xTitulo = margem;
  if (logo) {
    try {
      const dataUrl = await imagemDataUrl(logo);
      const altura = 12;
      const props = doc.getImageProperties(dataUrl);
      const largura = (props.width / props.height) * altura;
      doc.addImage(dataUrl, 'PNG', margem, y, largura, altura);
      xTitulo = margem + largura + 6;
    } catch (_) { /* sem logo, segue so com o titulo */ }
  }
  doc.setTextColor(...CORES_CENTRAO.verdeRgb);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.text(textoPdf(titulo || filename), xTitulo, y + 7.5);
  y += 14;
  doc.setFillColor(...CORES_CENTRAO.laranjaRgb);
  doc.rect(margem, y, larguraUtil, 1.2, 'F');
  y += 4;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(70, 70, 70);
  const sub = [subtitulo, `${rows.length} registro(s) · gerado em ${geradoEm}`].filter(Boolean).join('  |  ');
  doc.splitTextToSize(textoPdf(sub), larguraUtil).forEach((l) => { doc.text(l, margem, y + 3); y += 4.2; });
  y += 2;
  cabecalhoTabela();

  rows.forEach((row, r) => {
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(FONTE);
    const celulas = columns.map((c, i) => doc.splitTextToSize(textoPdf(c.value(row)), larguras[i] - PAD * 2));
    const altura = Math.max(1, ...celulas.map((l) => l.length)) * ALTURA_LINHA_TEXTO + PAD * 2;
    if (y + altura > alturaPagina - margem - 4) novaPagina();
    if (r % 2 === 1) {
      doc.setFillColor(...COR_ZEBRA);
      doc.rect(margem, y, larguraUtil, altura, 'F');
    }
    doc.setDrawColor(...COR_LINHA);
    doc.setLineWidth(0.15);
    doc.line(margem, y + altura, margem + larguraUtil, y + altura);
    doc.setTextColor(17, 17, 17);
    let x = margem;
    columns.forEach((c, i) => {
      const tx = c.alinhar === 'right' ? x + larguras[i] - PAD : x + PAD;
      doc.text(celulas[i], tx, y + PAD + 2.8, { align: c.alinhar === 'right' ? 'right' : 'left' });
      x += larguras[i];
    });
    y += altura;
  });

  // Rodape com paginacao
  const total = doc.getNumberOfPages();
  for (let p = 1; p <= total; p += 1) {
    doc.setPage(p);
    doc.setFillColor(...CORES_CENTRAO.verdeRgb);
    doc.rect(margem, alturaPagina - 8.5, larguraUtil, 0.6, 'F');
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(110, 110, 110);
    doc.text(`Página ${p} de ${total}`, larguraPagina - margem, alturaPagina - 5, { align: 'right' });
    doc.text(textoPdf(`Centrão Materiais de Construção · ${titulo}`), margem, alturaPagina - 5);
  }

  doc.save(filename.endsWith('.pdf') ? filename : `${filename}.pdf`);
}

export function exportToCsv(filename, columns, rows) {
  const header = columns.map((c) => escapeCell(c.label)).join(';');
  const body = rows
    .map((row) => columns.map((c) => escapeCell(c.value(row))).join(';'))
    .join('\n');

  const csv = `\uFEFF${header}\n${body}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
